const snakeCaseToKebabCase = snakeCaseValue => {
  return snakeCaseValue.replaceAll('_', '-');
};

export default snakeCaseToKebabCase;
